module.exports = __webpack_public_path__ + "img/telegram-logo.73f9a0ed.svg";